import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";

import AnimeImage from "../components/AnimeImage";
import AnimeInfo from "../components/AnimeInfo";
import MoreLike from "../components/MoreLike";

const AnimeDisplay = ({ openAuth }) => {
  const [animeInfo, setAnimeInfo] = useState();
  const [view, setView] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [screenWidth, setScreenWidth] = useState();
  let { id } = useParams();
  const [count, setCount] = useState(0);
  const [error, setError] = useState(null);
  const [page, setPage] = useState();

  useEffect(() => {
    if (id !== id.prev) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      fetchAnimeInfo();
      random();
      setCount(Math.floor(Math.random() * 15));
    }

    fetchAnimeInfo();
    handleResize();
  }, [id]);

  const fetchAnimeInfo = async () => {
    await fetch(`https://api.jikan.moe/v4/anime/${id}`)
      .then((res) => res.json())
      .then((response) => {
        setAnimeInfo(response.data);
      })
      .catch((error) => {
        setError(error);
      });
    setIsLoaded(true);
  };

  const random = () => {
    setPage(Math.floor(Math.random() * (3 - 1 + 1)));
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  const handleView = () => {
    setView(view ? false : true);
  };

  window.addEventListener("resize", handleResize);

  return (
    <>
      {animeInfo && isLoaded && (
        <div>
          <div className="flex fex-col flex-wrap lg:flex-row lg:flex-nowrap justify-center items-center w-full h-full content-center my-sm">
            <AnimeImage animeInfo={animeInfo} screenWidth={screenWidth} />
            <AnimeInfo
              animeInfo={animeInfo}
              view={view}
              handleView={handleView}
              openAuth={openAuth}
            />
          </div>

          <MoreLike page={page} animeInfo={animeInfo} />
        </div>
      )}
    </>
  );
};

export default AnimeDisplay;
